import { render, staticRenderFns } from "./ImgTurnPage.vue?vue&type=template&id=b44fb1c6&scoped=true"
import script from "./ImgTurnPage.vue?vue&type=script&lang=js"
export * from "./ImgTurnPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44fb1c6",
  null
  
)

export default component.exports